import { HasIdNameDisplay } from "~/@shared/api-types/id-name-display"
import { InfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

type GetStudentApplicationCategories = InfraResponse<StudentApplicationCategories>

type StudentApplicationCategories = {
  application_categories: Array<HasIdNameDisplay>
}

export const fetchGetStudentApplicationCategories = defineFetcher((): Promise<GetStudentApplicationCategories> => {
  return GET("/student/application-categories")
})
